export default {
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            loading: false
        };
    },
    methods: {
        /**
         * Start loading.
         */
        startLoading() {
            this.loading = true;
            this.$emit('loading-start');
        },
        /**
         * Finish loading.
         */
        finishLoading() {
            this.$nextTick(() => {
                this.loading = false;
                this.$emit('loading-stop');
            });
        }
    }
};
